import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/homebg.png'
import _imports_1 from '../assets/images/logo.png'
import _imports_2 from '../assets/images/title.png'
import _imports_3 from '../assets/images/icon-gl.png'
import _imports_4 from '../assets/images/bj.png'
import _imports_5 from '../assets/images/icon-key.png'
import _imports_6 from '../assets/images/icon-prop.png'
import _imports_7 from '../assets/images/dice-bg.png'
import _imports_8 from '../assets/images/icon-dice.png'
import _imports_9 from '../assets/images/hint.png'
import _imports_10 from '../assets/images/icon-hand.png'
import _imports_11 from '../assets/images/icon-gift.png'
import _imports_12 from '../assets/images/brand-title1.png'
import _imports_13 from '../assets/images/yxgl.png'
import _imports_14 from '../assets/images/smys.png'
import _imports_15 from '../assets/images/szjdj.png'
import _imports_16 from '../assets/images/shdjp.png'
import _imports_17 from '../assets/images/ycd.png'
import _imports_18 from '../assets/images/right-coin.png'
import _imports_19 from '../assets/images/btn-action-bg.png'
import _imports_20 from '../assets/images/title-mykey.png'
import _imports_21 from '../assets/images/lucky-btn.png'
import _imports_22 from '../assets/images/gift-box.png'
import _imports_23 from '../assets/images/icon-gift2.png'
import _imports_24 from '../assets/images/animate/1000.png'
import _imports_25 from '../assets/images/animate/2000.png'
import _imports_26 from '../assets/images/animate/3000.png'
import _imports_27 from '../assets/images/animate/4000.png'
import _imports_28 from '../assets/images/animate/5000.png'
import _imports_29 from '../assets/images/animate/6000.png'
import _imports_30 from '../assets/images/arrow.png'
import _imports_31 from '../assets/images/prize1.png'
import _imports_32 from '../assets/images/prize2.png'
import _imports_33 from '../assets/images/keygit.gif'


const _withScopeId = n => (_pushScopeId("data-v-353e1774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"\" class=\"homebg\" data-v-353e1774><div class=\"logo\" data-v-353e1774><img src=\"" + _imports_1 + "\" data-v-353e1774></div><div class=\"title\" data-v-353e1774><img src=\"" + _imports_2 + "\" data-v-353e1774></div>", 3)
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "operate" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "bgimg"
}, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "op-name" }, "钥匙", -1))
const _hoisted_12 = { class: "op-item item-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_14 = { class: "txt yellow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "op-name" }, "道具", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_17 = {
  class: "icon-dice",
  src: _imports_8
}
const _hoisted_18 = { class: "txt yellow" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "op-name" }, "机会", -1))
const _hoisted_20 = {
  key: 0,
  src: _imports_9,
  class: "hint"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_11 }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "op-name" }, "奖品", -1))
const _hoisted_25 = { class: "brand-content" }
const _hoisted_26 = { class: "brand-box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "theme-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_12 })
], -1))
const _hoisted_28 = { class: "brand-list" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "bd-logo" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_33 = { class: "main-title ellipsis1" }
const _hoisted_34 = { class: "sub-title ellipsis1" }
const _hoisted_35 = {
  key: 0,
  class: "guide-cont"
}
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<img class=\"introduction\" src=\"" + _imports_13 + "\" data-v-353e1774><img class=\"mysterious-key\" src=\"" + _imports_14 + "\" data-v-353e1774><img class=\"dice-prop\" src=\"" + _imports_15 + "\" data-v-353e1774><img class=\"my-prize\" src=\"" + _imports_16 + "\" data-v-353e1774><img class=\"easter-egg\" src=\"" + _imports_17 + "\" data-v-353e1774>", 5)
const _hoisted_41 = { class: "mine-key-layer custom-box" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_43 = { class: "module-title" }
const _hoisted_44 = {
  key: 0,
  class: "content"
}
const _hoisted_45 = {
  key: 1,
  class: "content"
}
const _hoisted_46 = { class: "lattice" }
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "已集齐20把钥匙，去合成钥匙大奖", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "钥匙已合成，去抽奖", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = { class: "btn-close" }
const _hoisted_55 = { class: "lottery-cont" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_57 = { class: "mine-key" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_20 }, null, -1))
const _hoisted_59 = { class: "collect-all" }
const _hoisted_60 = { class: "status" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "guide-txt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "under-line" }, "快快点击抽奖吧!")
], -1))
const _hoisted_62 = { class: "lucky-box" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_21 }, null, -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "prize-list" }
const _hoisted_66 = { class: "btn-close" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "gift-box",
  src: _imports_22
}, null, -1))
const _hoisted_68 = { class: "custom-box" }
const _hoisted_69 = { class: "module-title" }
const _hoisted_70 = { class: "content" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "领取奖品", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-tips" }, "奖品领取成功后，可以在“我的奖品”中查看", -1))
const _hoisted_77 = { class: "btn-close" }
const _hoisted_78 = { class: "custom-box" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "恭喜中奖!", -1))
const _hoisted_81 = {
  key: 0,
  class: "content pd40",
  style: {"text-align":"center"}
}
const _hoisted_82 = ["src"]
const _hoisted_83 = { class: "content" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:",
  class: "pink-text font-blod"
}, "我的奖品", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "再玩一次游戏吧！", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = ["src"]
const _hoisted_89 = { class: "content" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "领取奖品", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]
const _hoisted_93 = { class: "btn-close" }
const _hoisted_94 = { class: "custom-box" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "游戏机会", -1))
const _hoisted_97 = { class: "content flex-cont" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-gift",
  src: _imports_23
}, null, -1))
const _hoisted_99 = { class: "pour-box" }
const _hoisted_100 = { class: "content flex-cont" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-gift",
  src: _imports_23
}, null, -1))
const _hoisted_102 = { class: "pour1" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pour" }, [
  /*#__PURE__*/_createTextVNode("注：请到小程序"),
  /*#__PURE__*/_createElementVNode("span", null, "首页"),
  /*#__PURE__*/_createTextVNode("点击【"),
  /*#__PURE__*/_createElementVNode("span", null, "步数兑换"),
  /*#__PURE__*/_createTextVNode("】后进行慈善项目捐赠")
], -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "返回", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_106 = [
  _hoisted_104,
  _hoisted_105
]
const _hoisted_107 = { class: "btn-close" }
const _hoisted_108 = { class: "custom-box" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "我的道具", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-gift",
  src: _imports_23
}, null, -1))
const _hoisted_112 = ["onClick"]
const _hoisted_113 = {
  key: 1,
  class: "content"
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "暂无道具~", -1))
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = { class: "btn-close" }
const _hoisted_117 = { class: "custom-box" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "我的道具", -1))
const _hoisted_120 = { class: "control" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "前进", -1))
const _hoisted_122 = { class: "step-list" }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-tips" }, "注：每前进1格，将在小程序中增加1000步步数", -1))
const _hoisted_125 = { class: "btn-close" }
const _hoisted_126 = { class: "strategy-box" }
const _hoisted_127 = {
  key: 0,
  src: _imports_24
}
const _hoisted_128 = {
  key: 1,
  src: _imports_25
}
const _hoisted_129 = {
  key: 2,
  src: _imports_26
}
const _hoisted_130 = {
  key: 3,
  src: _imports_27
}
const _hoisted_131 = {
  key: 4,
  src: _imports_28
}
const _hoisted_132 = {
  key: 5,
  src: _imports_29
}
const _hoisted_133 = {
  key: 1,
  class: "layer"
}
const _hoisted_134 = { class: "strategy-box" }
const _hoisted_135 = ["src"]
const _hoisted_136 = { class: "btn-close1" }
const _hoisted_137 = {
  key: 0,
  class: "custom-box"
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "挑战任务", -1))
const _hoisted_140 = { class: "question-box" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ques-type" }, null, -1))
const _hoisted_142 = { class: "content" }
const _hoisted_143 = { class: "que-name" }
const _hoisted_144 = {
  key: 0,
  class: "que-media"
}
const _hoisted_145 = ["src"]
const _hoisted_146 = {
  key: 1,
  class: "answer-list"
}
const _hoisted_147 = ["onClick"]
const _hoisted_148 = {
  key: 0,
  class: "qus-clues"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_30 }, null, -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "确认", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_152 = [
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = {
  key: 2,
  class: "chance"
}
const _hoisted_154 = { class: "btn-close" }
const _hoisted_155 = {
  key: 0,
  class: "custom-box"
}
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_157 = {
  key: 0,
  class: "module-title"
}
const _hoisted_158 = { class: "block" }
const _hoisted_159 = { class: "video-cont" }
const _hoisted_160 = ["src", "poster"]
const _hoisted_161 = { class: "btn-close" }
const _hoisted_162 = {
  key: 0,
  class: "custom-box"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_164 = {
  key: 0,
  class: "content pd40"
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pd10" }, "获得", -1))
const _hoisted_166 = {
  key: 0,
  class: "pink-text font-blod",
  style: {"font-size":"16px"}
}
const _hoisted_167 = {
  key: 0,
  src: _imports_31
}
const _hoisted_168 = {
  key: 1,
  src: _imports_32
}
const _hoisted_169 = {
  key: 1,
  class: "pink-text font-blod",
  style: {"font-size":"16px"}
}
const _hoisted_170 = {
  key: 1,
  class: "content pd40"
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "继续游戏", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_173 = [
  _hoisted_171,
  _hoisted_172
]
const _hoisted_174 = { class: "txt" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_176 = { class: "btn-close" }
const _hoisted_177 = { class: "custom-box" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "decorate",
  src: _imports_18
}, null, -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "温馨提示：", -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content pd20",
  style: {"font-size":"14px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "pd10" }, "已完成当前格子任务，请继续游戏吧!")
], -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "继续游戏", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_19 }, null, -1))
const _hoisted_183 = [
  _hoisted_181,
  _hoisted_182
]
const _hoisted_184 = { class: "btn-close" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "decorate",
    src: _imports_18
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "content",
    style: {"font-size":"14px","padding":"20px 0 20px 40px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("您还有钥匙大奖未领取！"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("可至“奖品”中查看")
    ])
  ])
], -1))
const _hoisted_186 = { class: "btn-close" }
const _hoisted_187 = {
  key: 2,
  class: "layer1"
}
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_33,
  alt: ""
}, null, -1))
const _hoisted_189 = [
  _hoisted_188
]
const _hoisted_190 = { class: "custom-box identify-QR" }
const _hoisted_191 = ["src"]
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "长按识别二维码", -1))
const _hoisted_193 = { class: "btn-close" }

import { ref, onMounted, nextTick } from 'vue';
import MapView from '@/components/MapView.vue';
import { useRouter, useRoute } from 'vue-router';
import { RockingDiceApi, GetUserDataInfo, GetUserPropsApi, GetGameOpportunityApi, UserLogin, UserHandleLotteryApi, KeyLotteryPrizeList, GetBrandApi, UsePropAddGameNum, getKeyLatticeList } from "@/api/index"
import { Local, Session } from '@/utils/storage';
import { showLoadingToast, showToast, showDialog, showConfirmDialog } from 'vant';
import request from '@/utils/request';
import wx from 'weixin-js-sdk'
const diceAnimateTime = 1600; //骰子动画时长

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const mapViewRef = ref();
const showGuideLayer = ref(false); //引导界面
const showMineKeyLayer = ref(false);//我的钥匙弹窗
const showLottoryLayer = ref(false);//我的钥匙-抽奖弹窗
const showWinPrizeLayer = ref(false);//中奖弹窗
const showReceiveLayer = ref(false);//领取成功弹窗
const showOpportunityLayer = ref(false);//游戏机会弹窗
const showMinePropsLayer = ref(false);//我的道具弹窗
const showControlPropLayer = ref(false);//遥控骰子弹窗
const showIntroductionLayer = ref(false);//查看攻略弹窗
const showQuestionLayer = ref(false);//趣味解密弹窗
const showVideoLayer = ref(false);//看视频获得道具弹窗
const showAnswerResLayer = ref(false);//回答结果弹窗
const videoFinish = ref(false); //视频是否结束
const showHintResLayer = ref(false); //温馨提示框
const stepLatticeLayer = ref(false); //步数弹框
const stepLatticeNumber = ref(0); //
const syntheticKeyLayer = ref(false); //合成钥匙的弹框
const identifyQRModal = ref(false); //二维码弹框
const identifyQRCode = ref(''); //二维码弹框
const videoTime = ref(0);
const countDown = ref();


const receivePrize = ref<any>({})
const luckyNum = ref(-1); //中奖索引
const isRolling = ref(false);//是否摇骰子中
const isPlaying = ref(false);//是否指示器移动中
const isDiceMove = ref(false); //骰子向上移动
const isInTheLucky = ref(false);//是否正在抽奖
const isRepSub = ref(false);//防重复提交
const isFirst = ref(false)
const prizeHintModal = ref(false)
const guidTime = ref(5000);
const stepList = ref<Array<number>>([1, 2, 3, 4, 5, 6]);
const stepNumber = ref(0);
const userInfo = ref<any>({});
const gameStrategy = ref<any>();
const userNumInfo = ref({
  keyNum: 0,
  propNum: 0,
  opportunityNum: 0,
  gameNum: 0,
  prize: null,
  prizeNum: 0,
  prizeKey: 1
});
const userPropLList = ref<Array<any>>([]);//用户道具
const keyPrizeList = ref<Array<any>>([]);//钥匙奖品列表
const prizeInfo = ref({} as any);//奖品中奖信息
const questionInfo = ref({} as any);//答题任务
const propGotInfo = ref({} as any);//道具得到信息
const userOpportunityInfo = ref({} as any);//用户机会
const brandList = ref<Array<any>>([]);//彩蛋列表
const cellIndex = ref(<Number>0)
const videoRef = ref()
const tokenStr = ref()
const isFirstAnswer = ref(0);  //第几次答题
const latticeList = ref<Array<any>>([]);//所有格式列表
onMounted(() => {
  const { openId } = route.query;
  // showDialog({
  //   title: 'openId',
  //   message: `${openId}`,
  // }).then(() => {
  //   // on close
  // });
  if (openId) {
    checkLogin(openId as string)
  }
})

//登录
const checkLogin = (openId: string) => {
  let tftUser = Session.get("TFT-User");
  if (tftUser) {
    userInfo.value = tftUser;
    init();
  } else {
    const toast = showLoadingToast({ message: "登录中...", loadingType: 'spinner', duration: 0, overlay: true })
    UserLogin({ openId }).then((res: any) => {
      toast.close();
      let { User, token } = res.resultObj;
      userInfo.value = User;
      Session.set("TFT-Token", token);
      Session.set("TFT-User", User);
      init();
    }).catch(() => toast.close());
  }
}
const init = () => {
  checkIsFirstIn();
  getUserOpportunity();
  getMineDataInfo();
  getKeyPrizeList();
  getBrandList();
  addUserParticipationNum();

}
//检查是否第一次进入，显示引导界面
const checkIsFirstIn = () => {
  let state = Local.get("TFT-First");
  if (state !== '1') {
    showGuideLayer.value = true;
    Local.set("TFT-First", "1")
  }
}
//每日登录获取领取机会
const claimGameOpportunity = () => {
  let { id } = userInfo.value;
  // if (isRepSub.value) return
  // isRepSub.value = true;
  // const toast = showLoadingToast({ message: "领取中...", loadingType: 'spinner', duration: 0, overlay: true })
  GetGameOpportunityApi({ userId: id }).then((res: any) => {
    // toast.close();
    // isRepSub.value = false
    if (res.success) {
      userOpportunityInfo.value.logInCollect = 1;
      userNumInfo.value.gameNum = userNumInfo.value.gameNum + 1
      Session.set("TFT-IsReceive", "1");
    }
  }).catch(() => { })
}
//记录进入次数
const addUserParticipationNum = () => {
  console.log(Session.get('TFT-IsPationNum'))
  if (Session.get('TFT-IsPationNum')) return
  request({
    url: "/userUi/addUserParticipationNum",
    method: "POST"
  }).then((res: any) => {
    if (res.success) {
      Session.set("TFT-IsPationNum", "1");
    }
  })
}

//获取用户道具
const getUserPropInfo = () => {
  const toast = showLoadingToast({ message: "加载中...", loadingType: 'spinner', duration: 0, overlay: true })
  const { id } = userInfo.value
  request({
    url: "/userUi/userProp?userId=" + id,
    method: "POST"
  }).then((res: any) => {
    toast.close();
    if (res.success) {
      userPropLList.value = res.resultObj;
      showMinePropsLayer.value = true;
    }
  }).catch(() => toast.close())
}
//获取用户游戏机会
const getUserOpportunity = () => {
  const { id } = userInfo.value
  request({
    url: "/userUi/userGameOpportunity?userId=" + id,
    method: "POST"
  }).then((res: any) => {
    if (res.success) {
      userOpportunityInfo.value = res.resultObj;
    }
  })
}
//获取我的道具和机会
const getMineDataInfo = () => {
  let { id } = userInfo.value;
  GetUserDataInfo({ userId: id }).then((res: any) => {
    if (res.success) {
      const { propNum, gameNum, keyNum, userGameOpportunityNum, prize, cell, prizeNum, getPrizeState, prizeKey } = res.resultObj;
      userNumInfo.value.gameNum = gameNum;
      userNumInfo.value.keyNum = keyNum;
      userNumInfo.value.propNum = propNum;
      userNumInfo.value.prize = prize;
      userNumInfo.value.prizeNum = prizeNum;
      userNumInfo.value.opportunityNum = userGameOpportunityNum;
      userNumInfo.value.prizeKey = prizeKey;
      cellIndex.value = cell >= 29 ? 0 : cell;
      if (getPrizeState) {
        if (Session.get('TFT-IsPrizeHint') === formatDate(new Date())) return
        prizeHintModal.value = true;
        Session.set("TFT-IsPrizeHint", formatDate(new Date()));
      }
      claimGameOpportunity();
    }
  }).catch(() => { })
}
const formatDate = (date: any) => {
  date = date ? new Date(date) : new Date();
  let timeStr =
    date.getFullYear() +
    "-" +
    dealLessTen(date.getMonth() + 1) +
    "-" +
    dealLessTen(date.getDate());
  return timeStr;
}
//处理日期.小于10 前面加 0
const dealLessTen = (num: any) => {
  if (num < 10) {
    return "0" + num;
  }
  return num;
}
//获取彩蛋
const getBrandList = () => {
  GetBrandApi().then((res: any) => {
    if (res.success) {
      brandList.value = res.resultObj;
    }
  }).catch(() => { })
}
//获取钥匙奖品列表
const getKeyPrizeList = () => {
  const { id: userId } = userInfo;
  KeyLotteryPrizeList({ userId }).then((res: any) => {
    if (res.success) {
      keyPrizeList.value = res.resultObj;
    }
  })
}
//点击骰子
const handleTheDice = () => {
  if (isRolling.value) return;
  if (isPlaying.value) return;
  let { gameNum } = userNumInfo.value;
  let { id: userId } = userInfo.value;
  if (gameNum <= 0) {
    return RockingDiceApi({ userId }).then((res: any) => {
      showToast(res.message)
    })
  }
  userNumInfo.value.gameNum--;
  isRolling.value = true;
  isPlaying.value = true;
  isFirst.value = true;
  // let startTime = +new Date();
  mapViewRef.value.dicePlayingBegin();
  RockingDiceApi({ userId }).then((res: any) => {
    if (res.success) {
      // let endTime = +new Date();
      let { stepNumber } = res.resultObj;
      // let diff = endTime - startTime;
      // let duration = diceAnimateTime - diff;
      // if (diff > diceAnimateTime) {
      //   let times = Math.floor(diff / diceAnimateTime);
      //   duration = diceAnimateTime - (diff - times * diceAnimateTime);
      // }
      let duration = 2000
      mapViewRef.value.dicePlayingEnd(duration, stepNumber);
      setTimeout(() => {
        isRolling.value = false;
      }, duration)
      setTimeout(() => {
        isPlaying.value = false;
        handleDiceCallback(res.resultObj)
      }, duration + stepNumber * 600 + 2000)
    } else {
      mapViewRef.value.dicePlayingEnd(0, stepNumber);
      isRolling.value = false;
      isPlaying.value = false;
    }
  })
}
//摇骰子之后获取道具、任务等方法回调
const handleDiceCallback = (resultObj: any) => {
  videoTime.value = 0;
  videoFinish.value = false;
  let { isPrize, cell, questionBank, prop, discountCoupon, questionBankOrVideo, video } = resultObj;
  if (isPrize === 1) {//奖品
    if (prop) {
      propGotInfo.value = {
        title: "恭喜",
        propName: prop.name + (prop.id === 1 ? '1个' : '1次'),  //1是骰子，2是遥控骰子
        type: 1
      }
      isFirstAnswer.value = 2
      userNumInfo.value.propNum++
      showAnswerResLayer.value = true;
    } else if (discountCoupon) { //优惠券
      if (!prop) {
        propGotInfo.value = {
          title: "恭喜",
          type: 2,
          propName: [{ ilk: 2, name: discountCoupon.name }]
        }
      }
      showAnswerResLayer.value = true;
    }

  } else if (isPrize === 2) { //任务格
    if (questionBankOrVideo === 1) { //答题获得道具
      let optionList = [];
      questionBank.serialNumber = cell.serialNumber;
      if (questionBank.chooseOne) optionList.push({ key: "chooseOne", value: questionBank.chooseOne, checked: false })
      if (questionBank.chooseTwo) optionList.push({ key: "chooseTwo", value: questionBank.chooseTwo, checked: false })
      if (questionBank.chooseThree) optionList.push({ key: "chooseThree", value: questionBank.chooseThree, checked: false })
      if (questionBank.chooseFour) optionList.push({ key: "chooseFour", value: questionBank.chooseFour, checked: false })
      questionBank.optionList = optionList;
      questionBank.userAnswer = '';//用户回答
      questionBank.cellType = cell.cellType;
      questionInfo.value = questionBank;
      showQuestionLayer.value = true;
    } else if (questionBankOrVideo === 2) { //观看视频获得道具
      video.serialNumber = cell.serialNumber;
      let num = parseInt(video.remark);
      videoTime.value = isNaN(num) ? 15000 : num * 1000;
      questionInfo.value = video;
      showVideoLayer.value = true;
    } else {
      if (cell.cellType === 1) return
      if (cell.id === 1) return
      showHintResLayer.value = true;
    }
  }
}

const videoPlay = () => {
  countDown.value.start();
}
const videoPause = () => {
  countDown.value.pause();
}
const handleTheDiceTest = () => {
  if (isRolling.value) return;
  if (isPlaying.value) return;
  isPlaying.value = true;
  isDiceMove.value = true;
  setTimeout(() => {
    isDiceMove.value = false;
    isRolling.value = true;
    let startTime = +new Date();
    mapViewRef.value.dicePlayingBegin();
    let endTime = +new Date();
    let stepNumber = Math.floor(Math.random() * 6);
    let diff = endTime - startTime;
    let duration = diceAnimateTime - diff + 1000;
    if (diff > diceAnimateTime) {
      let times = Math.floor(diff / diceAnimateTime);
      duration = diceAnimateTime - (diff - times * diceAnimateTime);
    }
    mapViewRef.value.dicePlayingEnd(duration, stepNumber);

    setTimeout(() => {
      isRolling.value = false;
    }, duration)
    setTimeout(() => {
      isPlaying.value = false;
    }, duration + stepNumber * 600)
  }, 500)
}
//点击钥匙
const handleViewKey = () => {
  const { prize, keyNum, prizeKey } = userNumInfo.value;
  keyLatticeList()
  return
  if (keyNum >= 20 && !prize) {
    showLottoryLayer.value = true;
  } else {
    // if(latticeList.value.length > 0) return showMineKeyLayer.value = true;
    keyLatticeList()
  }
}
const handleSynthesis1 = () => {
  showMineKeyLayer.value = false;
  syntheticKeyLayer.value = true;
  userNumInfo.value.prizeKey = 1;
  const { id } = userInfo.value;
  setTimeout(() => {
    syntheticKeyLayer.value = false
    showLottoryLayer.value = true;
  }, 2000)
  request({
    url: "/userUi/addPrizeKey?userId=" + id,
    method: "POST",
  }).then((res: any) => { })
}
const handleSynthesis2 = () => {
  showMineKeyLayer.value = false;
  showLottoryLayer.value = true;
}
const keyLatticeList = () => {
  const { id } = userInfo.value;
  getKeyLatticeList({ userId: id }).then((res: any) => {
    if (res.success) {
      latticeList.value = res.resultObj;
      showMineKeyLayer.value = true;
    }
  })
}
//点击抽奖
const handleLottery = () => {
  if (isInTheLucky.value) return;
  isInTheLucky.value = true;
  luckyNum.value = 0;
  let speed = 50;
  let timer = setInterval(() => {
    luckyNum.value++;
    if (luckyNum.value >= 8) luckyNum.value = 0;
  }, speed);
  let num = Math.floor(Math.random() * 8 + 1);
  const { id: userId } = userInfo.value;
  UserHandleLotteryApi({ userId }).then((res: any) => {
    if (res.success) {
      let data = res.resultObj;
      prizeInfo.value = data;
      userNumInfo.value.prize = data;
      clearInterval(timer);
      moveToIndex(num, speed, 0, 9 * 8 + num)
    } else {
      showToast(res.message);
      clearInterval(timer);
      isInTheLucky.value = false;
      showLottoryLayer.value = false;
    }
  }).catch(() => {
    clearInterval(timer);
    isInTheLucky.value = false;
    showLottoryLayer.value = false;
  })

}


//移动到指定位置
const moveToIndex = ((num: any, speed: number, start: number, end: number) => {
  speed += speed / end;
  setTimeout(() => {
    luckyNum.value++;
    start++;
    if (luckyNum.value >= 8) luckyNum.value = 0;
    if (start < end) {
      moveToIndex(num, speed, start, end);
    } else {
      userNumInfo.value.prizeNum++
      isInTheLucky.value = false;
      showLottoryLayer.value = false;
      showReceiveLayer.value = true;
    }
  }, speed);
});

//点击填写信息领取实物奖品
const handleToCollectPrize = () => {
  showReceiveLayer.value = false;
  showWinPrizeLayer.value = true;
}
//点击领取奖品
const handleReceivePrize = () => {
  const { prizeType, pickupMethod, id } = prizeInfo.value;
  const { id: userId } = userInfo.value;
  if (prizeType === 1) {
    let { userName, phone, address } = receivePrize.value;
    if (!userName) {
      showToast("请填写中奖人姓名");
      return
    }
    if (!phone) {
      showToast("请填写中奖人手机号");
      return
    }
    // if (pickupMethod === 1) {
    if (!address) {
      showToast("请填写中奖人收货地址");
      return
    }
    // }
    request({
      url: "/userPrize/update",
      method: "POST",
      data: {
        cancelState: 2,
        prizeId: id,
        userAddress: address,
        userId,
        userName,
        userPhone: phone
      }
    }).then((res: any) => {
      if (res.success) {
        showToast("领取成功!");
        showWinPrizeLayer.value = false;
      }
    })
  } else {
    showWinPrizeLayer.value = false;
  }
}

//点击使用道具 骰子
const hanleUseProp = (item: any) => {
  if (isRepSub.value) return
  isRepSub.value = true;
  showMinePropsLayer.value = false;
  if (item.propId === 1) {
    handleYbj(item)
  } else if (item.propId === 2) {
    showControlPropLayer.value = true;
    isRepSub.value = false;
  }
}
//点击骰子
const handleYbj = (item: any) => {
  let { id: userId } = userInfo.value;
  UsePropAddGameNum({ userId, stepNumber: '', propId: 1 }).then((res: any) => {
    isRepSub.value = false;
    if (res.success) {
      userNumInfo.value.propNum--
      userNumInfo.value.gameNum++
      userOpportunityInfo.value.useNum++
    }
  })
}
//点击遥控骰子
const handleControlYbj = (step: number) => {

  let { id: userId } = userInfo.value;
  if (isPlaying.value) return
  isPlaying.value = true;
  RockingDiceApi({ userId, stepNumber: step, propId: 2 }).then((res: any) => {
    if (res.success) {
      stepLatticeNumber.value = step;
      showControlPropLayer.value = false;
      stepLatticeLayer.value = true
      setTimeout(() => {
        userNumInfo.value.propNum--
        stepLatticeLayer.value = false
        mapViewRef.value.mapPointMove(step, 612);
        setTimeout(() => {
          isPlaying.value = false;
          handleDiceCallback(res.resultObj)
        }, step * 600)
        // handleDiceCallback(res.resultObj);
      }, 2000)
    } else {
      isPlaying.value = false;
    }
  })
}
//页面跳转
const pageJump = (url: string) => {
  router.push(url)
}

//跳转小程序
const jumpMiniProgram = (item: any) => {
  if (!item.jumpConnection) return
  if (item.connectType === 1) {
    window.location.href = item.jumpConnection
  } else if (item.connectType === 2) {
    if (item.jumpApp === 1) {
      identifyQRCode.value = item.appCode
      identifyQRModal.value = true
    } else {
      wx.miniProgram.navigateTo({
        url: item.jumpConnection
      });
    }
  }
}
const jumpMiniStep = (item: any) => {
  wx.miniProgram.navigateTo({
    url: '/pages/step/step'
  });
}
//点击答题选项
const handleAnswerItem = (item: any) => {
  let { type, optionList } = questionInfo.value;
  if (type === 2) {
    return item.checked = !item.checked;
  }
  if (item.checked) {
    return
  }
  if (type === 1) { //单选
    optionList.forEach((it: any) => it.checked = false)
  }
  item.checked = true;
}

//点击回答问题
const fieldQuestions = () => {
  console.log(questionInfo.value)
  let { type, optionList, userAnswer, id, serialNumber } = questionInfo.value;
  let result = "";
  if (type === 3) {
    if (!userAnswer) {
      showToast("请填写答案");
      return;
    }
    result = userAnswer;
    answerFuc(result)
  } else {
    let list = optionList.filter((it: any) => it.checked);
    if (!list.length) {
      showToast("请选择答题选项");
      return
    }
    result = list.map((it: any) => it.value).join(",");
    answerFuc(result)
  }
}
const answerFuc = (result: any) => {
  let { type, optionList, userAnswer, id, serialNumber } = questionInfo.value;
  const { id: userId } = userInfo.value;

  request({
    url: "/questionBankUi/answer",
    method: "POST",
    data: {
      questionBankId: id,
      result,
      userId,
      serialNumber: serialNumber
    }
  }).then((res: any) => {

    if (res.success) {
      isFirstAnswer.value = 2
      if (!res.resultObj || (res.resultObj && res.resultObj.isKey === 2 && !res.resultObj.discountCoupon)) {

        if (res.resultObj.type === 1) {
          if (res.resultObj.cellType === 3) {
            propGotInfo.value = {
              type: 2, title: "答题正确，恭喜完成任务",
              propName: '',
              cellType: res.resultObj.cellType
            }
            showAnswerResLayer.value = true;
            showQuestionLayer.value = false;
            return
          } else {
            showAnswerResLayer.value = false;
            showQuestionLayer.value = false;
            return showToast("奖励已抽完，敬请期待下一次奖励!")
          }

        };
        return
      }
      const { isKey, keyNum, discountCoupon, type, cellType } = res.resultObj;

      let list = [];
      // if (isKey === 1) list.push("钥匙");
      // if (discountCoupon) list.push("优惠券");
      if (isKey === 1) {
        list.push({ ilk: 1, name: `一把钥匙（${keyNum}/20）` });
        userNumInfo.value.keyNum++
      }
      if (discountCoupon) {
        list.push({ ilk: 2, name: discountCoupon.name });
        userNumInfo.value.prizeNum++
      }
      propGotInfo.value = {
        type: 2, title: "答题正确，恭喜完成任务",
        // propName: list.join('+ ')
        propName: list,
        cellType
      }
    } else {
      if (res.resultObj.cellType === 3) {
        isFirstAnswer.value++
      } else {
        isFirstAnswer.value = 2
      }
      propGotInfo.value = {
        type: 1, title: "答题错误，未完成任务",
        cellType: res.resultObj.cellType
      }
    }
    showAnswerResLayer.value = true;
    showQuestionLayer.value = false;
  }).catch(() => {

  })
}
const lookAnswers = () => {
  let { connectType, resultConnect, jumpApp, appCode } = questionInfo.value;
  if (!resultConnect && !appCode) return
  if (connectType === 1) {
    window.location.href = resultConnect
  } else if (connectType === 2) {
    if (jumpApp === 1) {
      identifyQRCode.value = appCode
      identifyQRModal.value = true
    } else {
      wx.miniProgram.navigateTo({
        url: resultConnect
      });
    }
  }
}
//视频观看完成获得道具
const onVideoFinish = (status = true) => {
  if (videoFinish.value) return
  videoFinish.value = true;
  const { id: userId } = userInfo.value;
  const { serialNumber } = questionInfo.value;
  request({
    url: "/videoUi/videoAccomplish",
    method: "POST",
    data: {
      serialNumber,
      trueOrFalse: status,
      userId: userId
    }
  }).then((res: any) => {
    if (res.success) {
      if (!res.resultObj || (res.resultObj && res.resultObj.isKey === 2 && !res.resultObj.discountCoupon)) {
        showAnswerResLayer.value = false;
        showVideoLayer.value = false;
        if (res.resultObj.type === 1) return showToast("奖励已抽完，敬请期待下一次奖励!");
        return
      }
      const { isKey, keyNum, discountCoupon } = res.resultObj;
      let list = [];
      if (isKey === 1) {
        list.push({ ilk: 1, name: `一把钥匙（${keyNum}/20）` });
        userNumInfo.value.keyNum++
      }
      if (discountCoupon) {
        list.push({ ilk: 2, name: discountCoupon.name })
        userNumInfo.value.prizeNum++
      };
      propGotInfo.value = {
        type: 2, title: "恭喜完成任务！",
        propName: list,
        isVideo: 1
      }
      showAnswerResLayer.value = true;
      countDown.value.reset();
      showVideoLayer.value = false;
    }
  })
}
// handleCloseVideo  showVideoLayer videoTime timeData.seconds
const handleCloseVideo = () => {
  if (videoFinish.value) {
    showVideoLayer.value = false
    videoFinish.value = true

  } else {
    showConfirmDialog({
      title: '提示',
      message: '关闭后将不会得到对应奖励，确定要关闭吗？',
    }).then(() => {
      countDown.value.pause();
      showVideoLayer.value = false
      videoFinish.value = true
    }).catch(() => {

    });
  }

}
const handleCloseQues = () => {
  showConfirmDialog({
    title: '提示',
    message: '关闭后将不会得到对应奖励，确定要关闭吗？',
  }).then(() => {
    showQuestionLayer.value = false
  }).catch(() => {

  });
}

const handleGameStrategy = () => {
  if (gameStrategy.value) return showIntroductionLayer.value = true
  request({
    url: "/gameConfigurationUi/gameStrategy",
    method: "POST",
  }).then((res: any) => {
    if (res.success) {
      gameStrategy.value = res.resultObj.picture;
      showIntroductionLayer.value = true
    }
  })
}
//重新答题
const handleReAnswer = () => {
  if (isFirstAnswer.value > 1) {
    showAnswerResLayer.value = false;
    setTimeout(() => {
      isFirstAnswer.value = 0
    }, 500)
    return
  }
  questionInfo.value.userAnswer = '';
  questionInfo.value.optionList.forEach((item: any) => {
    item.checked = false
  })
  showQuestionLayer.value = true

}
const handleCloseAnswer = () => {
  showAnswerResLayer.value = false;
  setTimeout(() => {
    isFirstAnswer.value = 0
  }, 500)
}

return (_ctx: any,_cache: any) => {
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_block = _resolveComponent("block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "strategy",
      onClick: handleGameStrategy
    }, _hoisted_6),
    _createVNode(MapView, {
      ref_key: "mapViewRef",
      ref: mapViewRef,
      cellIndex: cellIndex.value
    }, null, 8, ["cellIndex"]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", {
        class: "op-item item-key",
        onClick: handleViewKey
      }, [
        (userNumInfo.value.keyNum > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(userNumInfo.value.keyNum), 1))
          : _createCommentVNode("", true),
        _hoisted_10,
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", {
          class: "key-cont",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (getUserPropInfo()))
        }, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(userNumInfo.value.propNum > 0 ? ('+') : '') + _toDisplayString(userNumInfo.value.propNum), 1),
          _hoisted_15
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["btn-dice", { 'animate': isDiceMove.value, 'animate1': !isDiceMove.value && isFirst.value}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTheDice()))
        }, [
          _hoisted_16,
          _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
            [_vShow, !isRolling.value]
          ])
        ], 2),
        _createElementVNode("div", {
          class: "key-cont",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showOpportunityLayer.value = true))
        }, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(userNumInfo.value.gameNum > 0 ? ('+') : '') + _toDisplayString(userNumInfo.value.gameNum), 1),
          _hoisted_19
        ]),
        (userNumInfo.value.gameNum > 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_20))
          : _createCommentVNode("", true),
        _hoisted_21
      ]),
      _createElementVNode("div", {
        class: "op-item item-prize item-key",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (pageJump('/minePrize')))
      }, [
        (userNumInfo.value.prizeNum > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(userNumInfo.value.prizeNum), 1))
          : _createCommentVNode("", true),
        _hoisted_23,
        _hoisted_24
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "brand-item",
              key: index,
              onClick: ($event: any) => (jumpMiniProgram(item))
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("img", {
                  src: item.picture
                }, null, 8, _hoisted_31)
              ]),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, _toDisplayString(item.brandName), 1),
              _createElementVNode("div", _hoisted_34, _toDisplayString(item.content), 1)
            ], 8, _hoisted_29))
          }), 128))
        ])
      ])
    ]),
    (showGuideLayer.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", {
            class: "iknow",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {showGuideLayer.value = false;})
          }, [
            _createTextVNode(" 我知道了( "),
            _createVNode(_component_van_count_down, {
              time: guidTime.value,
              format: "ss",
              onFinish: _cache[4] || (_cache[4] = ($event: any) => (showGuideLayer.value = false))
            }, null, 8, ["time"]),
            _createTextVNode("s) ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showMineKeyLayer.value,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((showMineKeyLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, "我的钥匙（" + _toDisplayString(userNumInfo.value.keyNum) + "/20）", 1),
          (userNumInfo.value.prize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, "已获得钥匙大奖！"))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latticeList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      src: item.isGetKey === 2?item.cellBackgroundGray: item.cellBackground,
                      alt: "",
                      key: index
                    }, null, 8, _hoisted_47))
                  }), 128))
                ]),
                _createTextVNode(" 当前已获得" + _toDisplayString(userNumInfo.value.keyNum) + "把钥匙，集齐20把钥匙即获得终极大奖抽奖资格。完成普通任务即可获得1把钥匙，详见\"活动攻略”。 ", 1)
              ])),
          (userNumInfo.value.keyNum >= 20 && !userNumInfo.value.prize && !userNumInfo.value.prizeKey)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "cus-btn cus-btn1",
                onClick: handleSynthesis1
              }, _hoisted_50))
            : _createCommentVNode("", true),
          (userNumInfo.value.keyNum >= 20 && !userNumInfo.value.prize && userNumInfo.value.prizeKey)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "cus-btn cus-btn1",
                onClick: handleSynthesis2
              }, _hoisted_53))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showMineKeyLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showLottoryLayer.value,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((showLottoryLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createTextVNode("(" + _toDisplayString(userNumInfo.value.keyNum) + "/20) ", 1)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, "已集齐" + _toDisplayString(userNumInfo.value.keyNum) + "把钥匙", 1),
            _hoisted_61
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", {
              class: "lucky-btn",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (handleLottery()))
            }, _hoisted_64),
            _createElementVNode("div", _hoisted_65, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyPrizeList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["prize-item", { 'active': index === luckyNum.value }]),
                  key: index
                }, _toDisplayString(item.prizeName), 3))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (showLottoryLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showWinPrizeLayer.value,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => ((showWinPrizeLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_67,
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, "恭喜抽中" + _toDisplayString(prizeInfo.value.prizeName), 1),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", null, "奖品名字：" + _toDisplayString(prizeInfo.value.prizeName), 1),
            (prizeInfo.value.pickupMethod === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, "领取方式：快递邮寄"))
              : _createCommentVNode("", true),
            (prizeInfo.value.pickupMethod === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, "领取方式：线下领取"))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_van_field, {
            modelValue: receivePrize.value.userName,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((receivePrize.value.userName) = $event)),
            label: "姓名：",
            border: false
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: receivePrize.value.phone,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((receivePrize.value.phone) = $event)),
            type: "tel",
            label: "电话：",
            border: false
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: receivePrize.value.address,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((receivePrize.value.address) = $event)),
            type: "textarea",
            label: "地址：",
            border: false
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "cus-btn",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (handleReceivePrize()))
          }, _hoisted_75),
          _hoisted_76
        ]),
        _createElementVNode("div", _hoisted_77, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (showWinPrizeLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showReceiveLayer.value,
      "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => ((showReceiveLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _hoisted_79,
          _hoisted_80,
          (prizeInfo.value.prizeType > 1 )
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _createElementVNode("img", {
                  class: "gift-box",
                  src: prizeInfo.value.prizePicture
                }, null, 8, _hoisted_82),
                _createElementVNode("div", _hoisted_83, _toDisplayString(prizeInfo.value.prizeName) + "！", 1),
                _hoisted_84,
                _createTextVNode("中查看发放情况 "),
                _createElementVNode("div", {
                  class: "cus-btn",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (showReceiveLayer.value = false))
                }, _hoisted_87)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("img", {
                  class: "gift-box",
                  src: prizeInfo.value.prizePicture
                }, null, 8, _hoisted_88),
                _createElementVNode("div", _hoisted_89, _toDisplayString(prizeInfo.value.prizeName) + "！", 1),
                _createElementVNode("div", {
                  class: "cus-btn",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (handleToCollectPrize()))
                }, _hoisted_92)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (showReceiveLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showOpportunityLayer.value,
      "onUpdate:show": _cache[23] || (_cache[23] = ($event: any) => ((showOpportunityLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_94, [
          _hoisted_95,
          _hoisted_96,
          _createElementVNode("div", _hoisted_97, [
            _hoisted_98,
            _createTextVNode(" 每日登录领取(" + _toDisplayString(userOpportunityInfo.value.logInCollect) + "/1) ", 1)
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _hoisted_101,
              _createElementVNode("span", _hoisted_102, "每日捐赠慈善币(" + _toDisplayString(userOpportunityInfo.value.lovingDonation) + "/" + _toDisplayString(userOpportunityInfo.value.lovingDonation > 1?userOpportunityInfo.value.lovingDonation:1) + ")", 1)
            ]),
            _hoisted_103
          ]),
          _createElementVNode("div", {
            class: "cus-btn",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (showOpportunityLayer.value = false))
          }, _hoisted_106)
        ]),
        _createElementVNode("div", _hoisted_107, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (showOpportunityLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showMinePropsLayer.value,
      "onUpdate:show": _cache[25] || (_cache[25] = ($event: any) => ((showMinePropsLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_108, [
          _hoisted_109,
          _hoisted_110,
          (userPropLList.value.length > 0)
            ? (_openBlock(), _createBlock(_component_block, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userPropLList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content flex-cont",
                      key: index
                    }, [
                      _hoisted_111,
                      _createTextVNode(" " + _toDisplayString(item.name) + "(" + _toDisplayString(item.useNum) + "/" + _toDisplayString(item.propNum) + ") ", 1),
                      (item.useNum < item.propNum)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn",
                            onClick: ($event: any) => (hanleUseProp(item))
                          }, "点击使用", 8, _hoisted_112))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_113, _hoisted_115))
        ]),
        _createElementVNode("div", _hoisted_116, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (showMinePropsLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showControlPropLayer.value,
      "onUpdate:show": _cache[27] || (_cache[27] = ($event: any) => ((showControlPropLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_117, [
          _hoisted_118,
          _hoisted_119,
          _createElementVNode("div", _hoisted_120, [
            _hoisted_121,
            _createElementVNode("div", _hoisted_122, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList.value, (step, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["step-item", stepNumber.value === step ? 'btn-yellow-plain' : 'btn-green-plain']),
                  key: index,
                  onClick: ($event: any) => (handleControlYbj(step))
                }, _toDisplayString(step) + "个格子 ", 11, _hoisted_123))
              }), 128))
            ])
          ]),
          _hoisted_124
        ]),
        _createElementVNode("div", _hoisted_125, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (showControlPropLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: stepLatticeLayer.value,
      "onUpdate:show": _cache[28] || (_cache[28] = ($event: any) => ((stepLatticeLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_126, [
          (stepLatticeNumber.value === 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_127))
            : _createCommentVNode("", true),
          (stepLatticeNumber.value === 2)
            ? (_openBlock(), _createElementBlock("img", _hoisted_128))
            : _createCommentVNode("", true),
          (stepLatticeNumber.value === 3)
            ? (_openBlock(), _createElementBlock("img", _hoisted_129))
            : _createCommentVNode("", true),
          (stepLatticeNumber.value === 4)
            ? (_openBlock(), _createElementBlock("img", _hoisted_130))
            : _createCommentVNode("", true),
          (stepLatticeNumber.value === 5)
            ? (_openBlock(), _createElementBlock("img", _hoisted_131))
            : _createCommentVNode("", true),
          (stepLatticeNumber.value === 6)
            ? (_openBlock(), _createElementBlock("img", _hoisted_132))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (showIntroductionLayer.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
          _createElementVNode("div", _hoisted_134, [
            _createElementVNode("img", { src: gameStrategy.value }, null, 8, _hoisted_135)
          ]),
          _createElementVNode("div", _hoisted_136, [
            _createVNode(_component_van_icon, {
              name: "close",
              onClick: _cache[29] || (_cache[29] = ($event: any) => (showIntroductionLayer.value = false))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showQuestionLayer.value,
      "onUpdate:show": _cache[32] || (_cache[32] = ($event: any) => ((showQuestionLayer).value = $event)),
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        (questionInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
              _hoisted_138,
              _hoisted_139,
              _createElementVNode("div", _hoisted_140, [
                _hoisted_141,
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, _toDisplayString(questionInfo.value.type === 1?'单选题：':(questionInfo.value.type === 2?'多选题：':'问答题：')) + _toDisplayString(questionInfo.value.name), 1),
                  (questionInfo.value.picture)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                        _createElementVNode("img", {
                          src: questionInfo.value.picture
                        }, null, 8, _hoisted_145)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (questionInfo.value.type === 3)
                  ? (_openBlock(), _createBlock(_component_van_field, {
                      key: 0,
                      modelValue: questionInfo.value.userAnswer,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((questionInfo.value.userAnswer) = $event)),
                      placeholder: "请输入答案",
                      border: false
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_146, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionInfo.value.optionList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["answer-item", item.checked ? 'btn-yellow-plain' : 'btn-green-plain']),
                          key: item.key,
                          onClick: ($event: any) => (handleAnswerItem(item))
                        }, _toDisplayString(item.value), 11, _hoisted_147))
                      }), 128))
                    ]))
              ]),
              (questionInfo.value.clues)
                ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    _createTextVNode("线索提示："),
                    _createElementVNode("span", null, _toDisplayString(questionInfo.value.clues), 1)
                  ]))
                : _createCommentVNode("", true),
              (questionInfo.value.resultConnect || questionInfo.value.appCode)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: lookAnswers,
                    class: "look-ans"
                  }, [
                    _createTextVNode(_toDisplayString(questionInfo.value.clues?'或者':'') + "去这里查找需要的答案", 1),
                    _hoisted_149
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "cus-btn",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (fieldQuestions()))
              }, _hoisted_152),
              (questionInfo.value.cellType === 2 || questionInfo.value.cellType === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(questionInfo.value.cellType === 3?'2':'1') + "次答题机会", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_154, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: handleCloseQues
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showVideoLayer.value,
      "onUpdate:show": _cache[33] || (_cache[33] = ($event: any) => ((showVideoLayer).value = $event)),
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        (showVideoLayer.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
              _hoisted_156,
              (videoTime.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                    _createTextVNode("看 "),
                    _createVNode(_component_van_count_down, {
                      ref_key: "countDown",
                      ref: countDown,
                      "auto-start": false,
                      time: videoTime.value,
                      onFinish: onVideoFinish
                    }, {
                      default: _withCtx((timeData) => [
                        _createElementVNode("span", _hoisted_158, _toDisplayString(timeData.seconds), 1)
                      ]),
                      _: 1
                    }, 8, ["time"]),
                    _createTextVNode("s视频完成任务 ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("video", {
                  ref_key: "videoRef",
                  ref: videoRef,
                  height: "165",
                  onPlay: videoPlay,
                  onPause: videoPause,
                  preload: "true",
                  playsinline: "",
                  "webkit-playsinline": "true",
                  "x5-video-player-type": "h5-page",
                  "x5-video-orientation": "portrait",
                  "x5-video-player-fullscreen": "true",
                  "x-webkit-airplay": "allow",
                  loop: "true",
                  src: questionInfo.value.videoAddress,
                  controls: "",
                  poster: questionInfo.value.picture
                }, null, 40, _hoisted_160)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_161, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: handleCloseVideo
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showAnswerResLayer.value,
      "onUpdate:show": _cache[34] || (_cache[34] = ($event: any) => ((showAnswerResLayer).value = $event)),
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        (propGotInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
              _hoisted_163,
              _createElementVNode("div", {
                class: _normalizeClass(["module-title", { 'green': propGotInfo.value.type === 2 }])
              }, _toDisplayString(propGotInfo.value.title), 3),
              (propGotInfo.value.propName && propGotInfo.value.cellType != 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                    _hoisted_165,
                    (propGotInfo.value.type === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propGotInfo.value.propName, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "list-it"
                            }, [
                              (item.ilk === 1)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_167))
                                : _createCommentVNode("", true),
                              (item.ilk === 2)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_168))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item.name), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_169, _toDisplayString(propGotInfo.value.propName), 1))
                  ]))
                : _createCommentVNode("", true),
              (!propGotInfo.value.propName  && propGotInfo.value.cellType != 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_170, "回答错误，下次跳到该任务格重新答题"))
                : _createCommentVNode("", true),
              (propGotInfo.value.type === 2)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "cus-btn",
                    onClick: handleCloseAnswer
                  }, _hoisted_173))
                : _createCommentVNode("", true),
              (propGotInfo.value.type === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "cus-btn",
                    onClick: handleReAnswer
                  }, [
                    _createElementVNode("span", _hoisted_174, _toDisplayString(isFirstAnswer.value > 1?'继续游戏':'重新答题'), 1),
                    _hoisted_175
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_176, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: handleCloseAnswer
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: showHintResLayer.value,
      "onUpdate:show": _cache[37] || (_cache[37] = ($event: any) => ((showHintResLayer).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_177, [
          _hoisted_178,
          _hoisted_179,
          _hoisted_180,
          _createElementVNode("div", {
            class: "cus-btn",
            onClick: _cache[35] || (_cache[35] = ($event: any) => (showHintResLayer.value = false))
          }, _hoisted_183)
        ]),
        _createElementVNode("div", _hoisted_184, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (showHintResLayer.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: prizeHintModal.value,
      "onUpdate:show": _cache[39] || (_cache[39] = ($event: any) => ((prizeHintModal).value = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_185,
        _createElementVNode("div", _hoisted_186, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[38] || (_cache[38] = ($event: any) => (prizeHintModal.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (syntheticKeyLayer.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_187, _hoisted_189))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      class: "transparent-bg cus-layer",
      show: identifyQRModal.value,
      "onUpdate:show": _cache[41] || (_cache[41] = ($event: any) => ((identifyQRModal).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_190, [
          _createElementVNode("img", {
            src: identifyQRCode.value,
            alt: ""
          }, null, 8, _hoisted_191),
          _hoisted_192
        ]),
        _createElementVNode("div", _hoisted_193, [
          _createVNode(_component_van_icon, {
            name: "close",
            onClick: _cache[40] || (_cache[40] = ($event: any) => (identifyQRModal.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})